<template>
  <div id="app">
    <div class="spinner"></div>
    <router-view/>
    <!-- set progressbar -->
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>


<script>
export default {
  name: 'app'
}
</script>




// WEBPACK FOOTER //
// src/App.vue